import React, {Component} from 'react';
import {Link} from 'react-router-dom';

// Elements
import AboutSection from "../elements/about";
import LatestNewsSection from "../elements/latest-news-slider";
import FeatureSection3 from "../elements/feature-section3";
import TeamSection from "../elements/team";
import TestimonialSection from "../elements/testimonial";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";

class AboutUs extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>About</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item">
												<Link to="/">
													<svg style={{marginTop: "3px"}} width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M2 12.8799H4.78854V8.6811C4.78854 8.46777 4.86069 8.28888 5.005 8.14444C5.14944 8.00013 5.32833 7.92798 5.54167 7.92798H8.45833C8.67167 7.92798 8.85056 8.00013 8.995 8.14444C9.13931 8.28888 9.21146 8.46777 9.21146 8.6811V12.8799H12V5.50798C12 5.46534 11.9906 5.42666 11.9719 5.39194C11.9533 5.35722 11.9279 5.32645 11.8958 5.29965L7.15229 1.73402C7.10951 1.69666 7.05875 1.67798 7 1.67798C6.94125 1.67798 6.89049 1.69666 6.84771 1.73402L2.10417 5.29965C2.07208 5.32645 2.04674 5.35722 2.02813 5.39194C2.00938 5.42666 2 5.46534 2 5.50798V12.8799ZM0.75 12.8799V5.50798C0.75 5.26951 0.803333 5.0436 0.91 4.83027C1.01681 4.6168 1.16431 4.44103 1.3525 4.30298L6.09625 0.729229C6.35944 0.528396 6.66028 0.427979 6.99875 0.427979C7.33722 0.427979 7.63889 0.528396 7.90375 0.729229L12.6475 4.30298C12.8357 4.44103 12.9832 4.6168 13.09 4.83027C13.1967 5.0436 13.25 5.26951 13.25 5.50798V12.8799C13.25 13.2207 13.1269 13.5142 12.8806 13.7605C12.6344 14.0067 12.3408 14.1299 12 14.1299H8.71479C8.50132 14.1299 8.32243 14.0576 8.17812 13.9132C8.03368 13.7689 7.96146 13.59 7.96146 13.3765V9.17798H6.03854V13.3765C6.03854 13.59 5.96632 13.7689 5.82188 13.9132C5.67757 14.0576 5.49868 14.1299 5.28521 14.1299H2C1.65917 14.1299 1.36562 14.0067 1.11937 13.7605C0.873125 13.5142 0.75 13.2207 0.75 12.8799Z" fill="#CBCCF0"/>
													</svg>
 													Home
												</Link>
											</li>
											<li className="breadcrumb-item active" aria-current="page">About Us</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<AboutSection />
					
					<FeatureSection3 />
					
					<TeamSection />
					
					<TestimonialSection />
					
					{/* <LatestNewsSection /> */}
				
				</div>
				
			</>
		);
	}
}

export default AboutUs;